import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './ErrorBanner.module.scss';

const ErrorBanner = ({ message }) => {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div className={styles['error-banner']}>
      <span className={styles['error-message']}>{message}</span>
      <button
        className={styles['close-icon']}
        onClick={() => setVisible(false)}
      >
        &times;
      </button>
    </div>
  );
};

ErrorBanner.propTypes = {
  message: PropTypes.string.isRequired
};

export default ErrorBanner;
